import { Typography } from "@mui/material";
import { DefaultCard, PageLayout } from "components";
import React from "react";

function RegisterPage() {
  return (
    <PageLayout>
      <DefaultCard title="REGISTER">
        <Typography variant="h4">
          <a
            target="_blank"
            rel="noopener noreferrer"
            href="https://form.jotform.com/dkbeauchamp/harmony-hill-registration-2025"
          >
            Register for Harmony Hill 2025
          </a>
        </Typography>
      </DefaultCard>
    </PageLayout>
  );
}

export default RegisterPage;
